export default function getResource(label, vars = []) {
    const resources = {
        // Free returns banner
        freeReturnsBannerPrefix: 'Free',
        freeReturnsBannerSuffix: ' 30 day returns in-store or online*',
        freeReturnsInfoAriaLabel: 'Return policy details',

        // Card labels (renamed per SHP-5111)
        freeShippingCardTitle: 'Free Shipping',
        fastDeliveryCardTitle: 'Fast Delivery',
        pickupCardTitle: 'Pickup',

        // Card ETAs
        pickupCardEta: 'As soon as today',
        fastDeliveryCardEta: 'As soon as today',

        // Gift card overrides (SHP-5234)
        availableInAllStoresCardTitle: 'Available in All Stores',
        fastDeliveryNotAvailable: 'Not available for this item',
        pickupNotAvailable: 'Not available for pickup',

        // Shipping details panel
        shippingPanelTo: 'to',
        shippingPanelZipAriaLabel: 'Change delivery location',
        shippingPanelInfoAriaLabel: 'Shipping and return policy details',
        shippingPanelBiPrefix: 'Beauty Insiders enjoy ',
        shippingPanelBiSuffix: 'FREE standard shipping',

        // Auto-Replenish row
        autoReplenishRowSavePercent: `Save ${vars[0]}`,
        autoReplenishRowSuffix: ' with Auto-Replenish',
        autoReplenishRowCheckboxAriaLabel: `Save ${vars[0]} with Auto-Replenish`,

        // Auto-Replenish expanded details (SHP-5122)
        deliveryEvery: 'Deliver every:',
        mostCommon: 'most common',
        deliveryFrequencyLinkAriaLabel: 'Change Auto-Replenish delivery frequency',
        autoReplenishRowNotEligible: 'Not eligible for Auto-Replenish',
        autoReplenishLegalOptIn: 'By enrolling, you consent to the recurring charge for your subscription.',
        learnMore: 'Learn more',
        autoReplenishFirstTimeLegalShown: `*First-time subscribers get ${vars[0]} off their first ${vars[1]} orders, delivered within ${vars[2]} months of the initial order placement. Promo period ends ${vars[3]}.`,
        autoReplenishFirstTimeLegalDetails: 'Details',
        autoReplenishFirstTimeLegalMoreDetails: `For each Hot Deal item, subscription and quantity is limited to 1 per customer. After ${vars[0]} replenishment orders at ${vars[1]} off or after ${vars[2]} months of the initial sign-up date, whichever comes first, the subscription renews at ${vars[3]} off.`,

        // Radiogroup
        fulfillmentMethodsGroupAriaLabel: 'Choose a fulfillment method'
    };

    return resources[label];
}
